import queries from '@apis/queries';
import useUser from '@hooks/auth/useUser';
import { useQuery } from '@tanstack/react-query';

function useCart(shopId: string) {
  const { user } = useUser();
  const { data: cartIdResponse, status } = useQuery({
    ...queries.cart.cartId(shopId),
    enabled: !!user,
    retry: false,
  });
  const cartId = cartIdResponse?.cartId;
  const { data: cart } = useQuery({
    ...queries.cart.detail(shopId, cartId!),
    enabled: !!cartId,
  });
  return status === 'success' ? cart : undefined;
}

export default useCart;
